export const SERVER_URL = 'https://api.cmonehealth.org';
